module.exports = __webpack_public_path__ + "img/vision_pic.9f6eef95.jpg";